import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';
class NotificationAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Notification';
  controllerName = 'Notifications';

  /**
   * Lấy danh sách thông báo
   * @param {} param 
   * @returns 
   * VDGiang 10/2/2022
   */
  async getPagingNotifications(param) {
    let queryString = commonFn.objectToQueryString(param);
    let request = {
        url: [this.getAPIUrl(), '/list?', queryString].join(''),
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy tổng số thông báo
   * @param {} param 
   * @returns 
   * VDGiang 10/2/2022
   */
  async getTotalNotificationCount(param) {
    let paramTotal = JSON.parse(JSON.stringify(param))
    delete paramTotal?.skip;
    delete paramTotal?.take;
    let queryString = commonFn.objectToQueryString(paramTotal);
    let request = {
        url: [this.getAPIUrl(), '/TotalNotificationCount?', queryString].join(''),
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Đánh dấu tất cả thông báo đã đọc
   * @param {} param 
   * @returns 
   * VDGiang 10/2/2022
   */
  async markAllAsRead(param) {
    let request = {
			url: [this.getAPIUrl(), 'IsView'].join('/'),
			data: param
		};
    return await httpClient.putAsync(request);
  }

  /**
   * Hàm cập nhật trạng thái của thông báo
   * @param {*} param 
   * @returns 
   */
   async updateNotificationIsViewed(param, id) {
    let queryString = commonFn.objectToQueryString(param);
    let request = {
			url: [this.getAPIUrl(), `/${id}/IsView?`, queryString].join(''),
		};
    return await httpClient.putAsync(request)
  }
}

export default new NotificationAPI();
